var _style, _path, _text, _text2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _text3, _path14, _text4, _path15, _text5, _path16, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st2{font-family:&apos;ArialMT&apos;}.st3{font-size:16.6465px}.st4{fill:#fff}.st5{fill:#369;fill-opacity:.502}.st6{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.1 162.4v-24.2h-476v24.2h476z",
    style: {
      fill: "#bfbfbf"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M613.8 163v-25.7H136.2V163h477.6m-1.4-24v22.6H137.9V139h474.5z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st2 st3",
    transform: "matrix(1.0001 0 0 1 140.9912 62.605)"
  }, "\n    10kg\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st2 st3",
    transform: "matrix(1.0001 0 0 1 553.041 62.605)"
  }, "\n    20kg\n  ")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M546.2 243.4v-62.1h-4.6v62.1h4.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M558.6 189c-6.2-7.8-11.2-16.7-14.8-26.6-3.5 9.9-8.4 18.8-14.8 26.6l14.8-5.4 14.8 5.4zM443.2 243.4v-62.1h-4.6v62.1h4.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M455.6 189c-6.2-7.8-11.2-16.7-14.8-26.6-3.5 9.9-8.4 18.8-14.8 26.6l14.8-5.4 14.8 5.4zM370.7 243.4v-62.1h-4.6v62.1h4.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.3 189c-6.3-7.8-11.2-16.7-14.8-26.6-3.6 9.9-8.6 18.8-14.8 26.6l14.8-5.4 14.8 5.4zM303.2 243.4v-62.1h-4.6v62.1h4.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.8 189c-6.3-7.8-11.2-16.7-14.8-26.6-3.6 9.9-8.6 18.8-14.8 26.6l14.8-5.4 14.8 5.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M585.7 78.2c-.7-7.2-4.6-11-11.8-11.7-7.2.6-11 4.5-11.7 11.7.6 7.2 4.5 11.1 11.7 11.8 7.2-.7 11.1-4.7 11.8-11.8m-4.8 0c-.4 4.2-2.8 6.5-7 6.8-4.1-.4-6.4-2.7-6.8-6.8.4-4.1 2.7-6.4 6.8-6.8 4.3.3 6.6 2.6 7 6.8z",
    className: "st4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M573.8 65.6c-7.6.7-11.8 4.9-12.6 12.6.7 7.8 4.9 12 12.6 12.8 7.8-.7 12-5 12.8-12.8-.7-7.7-5-11.9-12.8-12.6m10.9 12.6c-.1 3-1.2 5.6-3.1 7.8-2.2 2-4.7 3-7.8 3.1-3-.1-5.5-1.2-7.6-3.1-2.1-2.2-3.1-4.7-3.1-7.8 0-3.1 1-5.6 3.1-7.6 2.1-2.1 4.6-3.1 7.6-3.1s5.6 1 7.8 3.1c2 2 3 4.5 3.1 7.6m-18.6 0c.4 4.7 3 7.3 7.8 7.8 4.9-.5 7.5-3.1 8-7.8-.4-4.7-3.1-7.3-8-7.8-4.8.4-7.4 3-7.8 7.8m3.5 4.2c-1-1.2-1.6-2.6-1.7-4.3.1-1.7.6-3.1 1.7-4.3 1.1-1.1 2.5-1.7 4.3-1.7 3.7.3 5.7 2.3 6.1 5.9-.1 1.7-.7 3.1-1.8 4.3-1.1 1.1-2.5 1.7-4.3 1.7-1.8.1-3.2-.5-4.3-1.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M607.6 138.1l-13.9-59.7h-40L540 138.1h67.6z",
    className: "st4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M553.2 77.4v.7L539.1 139h69.7l-14.2-61.6h-41.4m53.3 59.8h-65.1l13.2-57.9h38.5l13.4 57.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M169.7 108.2c-.4-3.5-2.3-5.5-5.7-5.9-3.6.4-5.6 2.3-5.9 5.9.3 3.6 2.3 5.6 5.9 5.9 3.4-.3 5.3-2.3 5.7-5.9m-2.4 0c-.2 2.2-1.3 3.3-3.3 3.5-2.2-.2-3.4-1.4-3.5-3.5.1-2 1.3-3.1 3.5-3.3 2 .1 3.1 1.2 3.3 3.3z",
    className: "st4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.9 101.3c-4.3.4-6.5 2.7-6.8 6.8.3 4.2 2.6 6.5 6.8 6.8 4.1-.4 6.3-2.7 6.7-6.8-.4-4-2.6-6.3-6.7-6.8m-5 6.9c.2-3 1.9-4.7 5-5 2.9.3 4.5 2 4.8 5-.3 3.1-1.9 4.7-4.8 5-3-.3-4.7-1.9-5-5m5-4.3c-2.7.2-4.2 1.6-4.4 4.3.2 2.7 1.7 4.2 4.4 4.4 2.7-.2 4.1-1.7 4.3-4.4-.2-2.7-1.6-4.1-4.3-4.3m0 6.9c-1.6-.1-2.5-1-2.6-2.6.1-1.5 1-2.3 2.6-2.4 1.4.1 2.2.9 2.4 2.4-.1 1.6-.9 2.5-2.4 2.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.8 138.1l-6.8-29.8h-20l-7 29.8h33.8z",
    className: "st4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.7 108.2v-.7h-21.5l-7 30.5-.4 1.1h36.1l-.2-1.1-7-29.8m-26.6 29l6.6-27.9h18.5l6.4 27.9h-31.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M310 250.5c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6s3.6-5.3 3.6-8.7c0-3.4-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st2 st6",
    transform: "matrix(.9981 0 0 1 297.5171 264.1182)"
  }, "\n    1\n  ")), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M377.1 250.5c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6s3.6-5.3 3.6-8.7c0-3.4-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st2 st6",
    transform: "matrix(.9981 0 0 1 364.6172 264.1182)"
  }, "\n    2\n  ")), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M449.5 250.5c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6s3.6-5.3 3.6-8.7c0-3.4-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st2 st6",
    transform: "matrix(.9981 0 0 1 436.9668 264.1182)"
  }, "\n    3\n  ")), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M553.4 250.5c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st4 st2 st6",
    transform: "matrix(.9981 0 0 1 540.917 264.1182)"
  }, "\n    4\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem12);
export default __webpack_public_path__ + "static/media/item12.f449bf165e2e0132871b50efe4dc7b36.svg";
export { ForwardRef as ReactComponent };